<template>
  <div>
    <empty-card
      :table="true"
      :title="$t('menu.plans')"
    >
      <template #title>
        <b-button
          variant="dark"
          @click="handleEdit()"
        >
          {{ $t('package.add') }}
        </b-button>

      </template>
      <ok-table
        ref="datatable"
        :config="config"
        @edit="handleEdit"
        @delete="handleDelete"
      >
        <template
          slot="media_type-column"
          slot-scope="{props}"
        >
          <media-type-icon :icon="props.row.media_type" />
        </template>
      </ok-table>
    </empty-card>
    <process-plan-modal
      v-model="showEditModal"
      :plan="selectedPlan"
      @updated="refreshTable"
    />
  </div>
</template>

<script>
import EmptyCard from '@/@bya3/components/cards/EmptyCard'
import OkTable from '@/@bya3/components/tables/ok-table/OkTable'
import AdminPlansApi from '@/api/admin/plans'
import MediaTypeIcon from '@/@bya3/components/utils/MediaTypeIcon'
import ProcessPlanModal from '@/views/admin/plans/components/ProcessPlanModal'
import { BButton } from 'bootstrap-vue'
import PlansTableConfig from './config/plans-table-config'

export default {
  components: {
    ProcessPlanModal,
    MediaTypeIcon,
    EmptyCard,
    OkTable,
    BButton,
  },
  data() {
    return {
      config: PlansTableConfig,
      showEditModal: false,
      selectedPlan: {},
    }
  },
  methods: {
    refreshTable() {
      this.selectedPlan = {}
      this.$refs.datatable.loadItems()
    },
    handleEdit(props = null) {
      this.showEditModal = true
      this.selectedPlan = props?.row ?? null
    },
    handleDelete(data) {
      this.$okConfirm(this.$t('general.delete-confirm'), {
        preConfirm: () => AdminPlansApi.delete(data.row.id)
          .then(response => {
            this.$notifySuccess(response.message)
            this.refreshTable()
          })
          .catch(e => this.$notifyError(e)),
      })
    },
  },
}
</script>
